import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { UserService } from 'riterz-core';
import { AppService } from '../../services/app.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'rt-password-change',
  imports: [
    ReactiveFormsModule,
    ButtonModule,
    PasswordModule,
  ],
  standalone: true,
  templateUrl: './password-change.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordChangeComponent {
  private appService = inject(AppService);
  private dialogRef = inject(DynamicDialogRef);
  private userService = inject(UserService);

  readonly passwordChangeForm: FormGroup = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      Validators.pattern(/.*^(?=.{6,20})(?=.*[a-zA-Z])(?=.*[0-9]).*$/),
    ]),
  });

  readonly saving = signal<boolean>(false);

  submit(): void {
    if (this.passwordChangeForm.invalid) { return; }

    const params = this.passwordChangeForm.value;

    this.saving.set(true);
    this.userService
      .updateCurrentUser(params)
      .subscribe({
        next: () => {
          this.appService.showToast({ 
            severity: 'success', 
            summary: `Success`, 
            detail: `Password update successfully` 
          });

          this.appService.showDialog({ 
            acceptLabel: 'Close',
            acceptButtonStyleClass:"p-button-primary p-button-rounded",
            rejectVisible: false,
            header: `You’re good to go!`,
            message: `
              Your password is updated. Enjoy using Riterz!
            `,
          });

          this.dialogRef.close({ hasChanges: true });
          this.saving.set(false);
        },
        error: (error) => {     
          this.appService.showToast({ 
            severity: 'error', 
            summary: `Error`, 
            detail: error.message 
          });
          this.saving.set(false);
        }
      });
  }

  close(): void {
    this.dialogRef.close({ hasChanges: false });
  }
  
}